import React from 'react';

import { VideoContainer, Video } from './videoAnuncio-styled';

//TODO:  incluir uso de API
const VideoAnuncio = ({ anuncio }) => {
    const url = anuncio.urlVideo;

    function matchYoutubeUrl() {
        const urlAfterRegex =
            /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
        return url.match(urlAfterRegex) ? RegExp.$1 : false;
    }

    return (
        <VideoContainer>
            <Video>
                <iframe
                    width="560"
                    src={'https://www.youtube.com/embed/' + matchYoutubeUrl()}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                />
            </Video>
        </VideoContainer>
    );
};

export default VideoAnuncio;
